import { createSlice } from "@reduxjs/toolkit";
import { resetAll } from "./baseSlice";

const initialState = {
  loader: 0,
};

const loadingbarSlice = createSlice({
  name: "loadingbar",
  initialState,
  extraReducers: (builder) => builder.addCase(resetAll, () => initialState),
  reducers: {
    hideLoading: (state, action) => {
      state.loader = Math.max(0, (state.loader || 1) - 1);
    },
    showLoading: (state, action) => {
      state.loader = (state.loader || 0) + 1;
    },
    resetLoading: (state, action) => {
      state.loader = 0;
    },
  },
});

export const { hideLoading, showLoading, resetLoading } =
  loadingbarSlice.actions;
export default loadingbarSlice.reducer;
